import React, {Component} from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {
    awaitLoadCustomerHelp,
    isShowingHelpDesk,
    setHelpContext
} from "../prodect/HelpManager";
import LoadingAnimation from "../components/LoadingAnimation";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import {prosNotificationShow, prosPopupRender} from "../prodect/ProsPopup";
import TextInput from "../components/TextInput";
import {
    ATTR_AWS_PROJECT_ID,
    ATTR_CREATED_BY,
    ATTR_CREATED_MS_I,
    ATTR_CUSTOMER_GROUP,
    ATTR_DESCRIPTION,
    ATTR_MAIN_PROJ_ID,
    ATTR_OBJ_ID,
    ATTR_OBJ_STATE,
    ATTR_OBJ_TYPE,
    ATTR_PROJECT_END,
    ATTR_PROJECT_STATE,
    ATTR_SORT_ORDER_I,
    ATTR_TEXT,
    ATTR_UPDATED_BY,
    ATTR_UPDATED_MS_I,
    awaitGetProjects,
    currentTimeMs,
    datePickerReturnValueToMillisec,
    getCustomerSettings,
    getMainProject,
    isValueEmpty,
    millisecToDatePicker,
    OBJ_STATE_ACT,
    OBJ_STATE_PAS, OBJ_STATE_TO_DEL,
    OBJ_TYPE_ITM_PICT,
    OBJ_TYPE_ITM_PICT_LOC,
    PROJECT_NAME_MAX_LEN,
    PROJECT_NAME_MIN_LEN,
    ROLE_ADMIN,
    saveCustomerMainPrjHelp,
    STR_NO_VALUE,
    UI_LIST_LIMIT,
} from "../prodect/ProsConnect";
import {CustomerEnums} from "./CustomerEnums";
import SettingLocationPictures from "./SettingLocationPictures";
import BasicModal from "../components/BasicModal";
import prosAppNotif, {prosAppNotifWarn} from "../prodect/ProsAppNotif";
import {deleteMainProject} from "../prodect/ProjectManagement";
import PermissionManagement from "./PermissionManagement";
import {ATTR_CUSTOMER_BILL_REFERENCE, ATTR_TEXT_TO_BILL} from "./CreateMainProject";
import {
    getEndOfWorkingDayTimeMs,
    makeUiMainProjectList,
    openPictureImportModal,
    UiBoxMedia
} from "../prodect/ProsCommonUi";
import DatePicker from "../components/DatePicker";

const PAGE_MAIN_SETTINGS = 'settings'
const PAGE_HELP_SETTINGS = 'help'
const PAGE_CUST_ENUMS = 'cust_enums'
const PAGE_LOCT_PICTS = 'loctPicts'
const PAGE_PROJ_PERMS = 'proj_permissions'


export default class MainProjectSettings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            projectName: undefined,
            projectId: undefined,
            mainProject: undefined,
            loading: true,
            showHelpDesk: isShowingHelpDesk(),
            activePage: PAGE_MAIN_SETTINGS,
            refreshCounter: 0,
            isMasterAdmin: false,
            settings: {},
            serverCustomer: undefined,
            hasContentChanged: false,
            customHelp: undefined,
            projectEnd: STR_NO_VALUE,
        }
        this.mainProject = undefined
        this.subprojects = []
        this.mainProjId = props.customerAndProject[ATTR_MAIN_PROJ_ID] ?? undefined
        this.customerGroupId = undefined
        this.mainProjectList = undefined
    }

    async componentDidMount() {
        setHelpContext('mainProj-project')
        if ( ! this.mainProjId) {
            prosAppNotif('Projektia ei valittu')
            return
        }
        let mainProjectList = await makeUiMainProjectList('all')
        this.mainProjectList = mainProjectList.filter(mp => mp.mainProjectId !== this.mainProjId)
        await this.getCustomHelp()
        await this.setMainPrjSettings()
        if (this.mainProject) {
            let projects = await prosConnect.awaitGetProjects()
            if ( ! projects || ! this.mainProject.subprojects) {
                prosAppNotif('Projektien haku epäonnistui')
                return
            }
            this.subprojects = projects.filter(prj => this.mainProject.subprojects.indexOf(prj.project_id) !== -1)
        }
        this.refreshUi()
    }

    async setMainPrjSettings() {
        if ( ! this.mainProjId) {
            return
        }
        let change = {}
        let project = await getMainProject(this.mainProjId, true)
        if ( ! project) {
            prosAppNotifWarn('Ei voitu ladata projektia')
        } else {
            this.mainProject = project
            this.customerGroupId = project[ATTR_CUSTOMER_GROUP]
            change = {
                projectName: project[ATTR_TEXT],
                projectId: project[ATTR_OBJ_ID],
                pid: project[ATTR_AWS_PROJECT_ID],
                projectEnd: prosConnect.getValidAttr(project, ATTR_PROJECT_END, STR_NO_VALUE),
            }
            change[ATTR_CUSTOMER_GROUP] = project[ATTR_CUSTOMER_GROUP]
            change[ATTR_CUSTOMER_BILL_REFERENCE] = project[ATTR_CUSTOMER_BILL_REFERENCE]
            change[ATTR_TEXT_TO_BILL] = project[ATTR_TEXT_TO_BILL]
            let customerSettings = await getCustomerSettings(project.customer_group)
            change['serverCustomer'] = customerSettings
            this.setIsEMailInMasterAdmins(customerSettings)
        }
        this.setState({
            loading: false,
            hasContentChanged: false,
            ...change
        })
    }

    async getCustomHelp() {
        if ( ! this.mainProjId) {
            prosAppNotif('Ei pääprojektia valittuna')
            return
        }
        let customHelp = await prosConnect.getCustomerMainPrjHelp(this.mainProjId, false)
        this.setState({
            customHelp: customHelp
        })
    }

    async saveProjectSettings() {
        let mainProjectChanges = {}
        mainProjectChanges[ATTR_AWS_PROJECT_ID] = this.state.pid
        mainProjectChanges[ATTR_OBJ_ID] = this.mainProjId
        mainProjectChanges[ATTR_CUSTOMER_BILL_REFERENCE] = this.state[ATTR_CUSTOMER_BILL_REFERENCE]
        mainProjectChanges[ATTR_TEXT_TO_BILL] = this.state[ATTR_TEXT_TO_BILL]
        mainProjectChanges[ATTR_TEXT] = this.state.projectName
        mainProjectChanges[ATTR_PROJECT_END] = this.state.projectEnd
        await prosConnect.updateItemsAttributes(mainProjectChanges)
    }

    setActivePage(page) {
        if (page === this.state.activePage) {
            return
        }
        this.setState({
            activePage: page,
        })
    }

    async saveCustomerHelp(customerHelp) {
        await saveCustomerMainPrjHelp(this.mainProjId, customerHelp)
        await awaitLoadCustomerHelp(this.mainProjId, true)
    }

    renderSaveCancelButtons(){
        if ( ! this.state.hasContentChanged ||
            (this.state.activePage === PAGE_MAIN_SETTINGS && ! this.isProjectNameValid())) return null
        return(
            <footer className={"page-footer"}>
                <div className={"btn-set_center"}>
                    <CancelButton
                        action={async ()=> {
                            await this.getCustomHelp()
                            await this.setMainPrjSettings()
                        }}
                    />
                    <ConfirmButton
                        action={async () => {
                            if (this.state.activePage === PAGE_HELP_SETTINGS) {
                                await this.saveCustomerHelp(this.state.customHelp)
                            }
                            if (this.state.activePage === PAGE_MAIN_SETTINGS) {
                                await this.saveProjectSettings()
                            }
                            await this.getCustomHelp()
                            await this.setMainPrjSettings()
                            prosAppNotif('Muutokset tallennettu')
                        }}
                        disabled={this.state.loading}
                    />
                </div>
            </footer>
        )
    }

    limitExceededAlert(len, maxLen, note) {
        if (len > maxLen) {
            prosNotificationShow(this, note + ", raja " + maxLen);
            return true
        }
        return false;
    }

    isProjectNameValid(checkOnly) {
        return this.showReason(
                this.state.projectName && this.state.projectName.length >= PROJECT_NAME_MIN_LEN,
                "Anna projektille nimi - minimi pituus " + PROJECT_NAME_MIN_LEN, checkOnly)
            &&
            // check that name not already used
            this.showReason(!this.mainProjectList || !this.isProjectNameInUse(),
                "Projektin nimi on jo käytössä", checkOnly)
    }

    isProjectNameInUse() {
        if ( ! this.mainProjectList) {
            return true
        }
        return this.mainProjectList
            .find(mp => mp.name.toUpperCase() === this.state.projectName.toUpperCase())
    }

    async deleteMainProject() {
        await deleteMainProject(this.mainProjId, this.customerGroupId);
        await awaitGetProjects(true)
    }

    setIsEMailInMasterAdmins(serverCustomer) {
        if ( ! serverCustomer) {
            return
        }
        let ownEmail = prosConnect.getUserEmail(true)

        this.setState({
            isMasterAdmin:
                prosConnect.isSuperUserModeInUse() ||
                !serverCustomer.admin_emails ||
                serverCustomer.admin_emails === '' ||
                serverCustomer.admin_emails.indexOf(ownEmail) >= 0
        })
    }

    mayEditCustomerData() {
        return this.state.isMasterAdmin
    }

    handleProjectName(val) {
        if (this.limitExceededAlert(val.length, PROJECT_NAME_MAX_LEN, "Liian pitkä nimi")) {
            return
        }
        this.setState({
            projectName: prosConnect.filterSpecialChars(val),
            hasContentChanged: true,
        })
    }

    showReason(ok, whyNot, checkOnly= false) {
        if (ok) {
            return true
        }
        if (!checkOnly) {
            prosAppNotif(whyNot)
        }
    }

    isProjectNameValidForTextInput(){
        return this.state.projectName &&
            ! this.isProjectNameInUse() &&
            this.state.projectName.length >= PROJECT_NAME_MIN_LEN &&
            this.state.projectName.length <= PROJECT_NAME_MAX_LEN
    }

    renderMainProjectSettings() {
        let noteText = this.mayEditCustomerData() ?
            null : 'Vain asiakkaan pääkäyttäjät voivat muokata projektin laskutustietoja'
        return <>
            <h1>Yleiset asetukset</h1>
            <section>
                <div className="slab grid-container grid-1 grid-2_xl">
                    <div>
                        <TextInput
                            label={'Projektin nimi'}
                            value={this.state.projectName}
                            onChange={val => this.handleProjectName(val)}
                            disabled={false}
                            placeholder={"Kirjoita projektin nimi"}
                            isControlled={true}
                            required
                            isValid={this.isProjectNameValidForTextInput()}
                        />
                        <TextInput
                            label={'Viite laskuun'}
                            value={prosConnect.getValidAttr(this.state, ATTR_CUSTOMER_BILL_REFERENCE, '')}
                            disabled={!this.mayEditCustomerData()}
                            isControlled={true}
                            onChange={val => {
                                let change = {}
                                change[ATTR_CUSTOMER_BILL_REFERENCE] = val
                                change['hasContentChanged'] = true
                                this.setState(change)
                            }}
                            placeholder={"Kirjoita viite"}
                        />
                        <TextInput
                            label={'Projektikohtainen saateteksti laskuun'}
                            value={prosConnect.getValidAttr(this.state, ATTR_TEXT_TO_BILL, '')}
                            disabled={!this.mayEditCustomerData()}
                            isControlled={true}
                            onChange={val => {
                                let change = {}
                                change[ATTR_TEXT_TO_BILL] = val
                                change['hasContentChanged'] = true
                                this.setState(change)
                            }}
                            placeholder={"Kirjoita saateteksti"}
                            info={noteText}
                        />
                        <div>
                            <h2>Projektin kesto</h2>
                            <div className={"element-set width-100 flex-wrap"}>
                                <DatePicker
                                    label={'Päättymispäivä'}
                                    value={isValueEmpty(this.state.projectEnd) ? '' : millisecToDatePicker(this.state.projectEnd)}
                                    onChange={evt =>{
                                        const end = !isValueEmpty(evt.target.value) ? getEndOfWorkingDayTimeMs(datePickerReturnValueToMillisec(evt.target.value)) : ''
                                        this.setState({
                                            hasContentChanged: true,
                                            projectEnd: end
                                        })
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {this.renderSaveCancelButtons()}
        </>
    }

    renderTextInput(action, label = 'Otsikko', value= '') {
        if(value === STR_NO_VALUE) value = ''
        const multiline = action === ATTR_TEXT ? 1 : UI_LIST_LIMIT
        return <div>
            <TextInput
                label={label}
                value={value}
                multiline={multiline}
                onChange={val => {
                    let newValue = this.state.customHelp
                    newValue[action] = val
                    this.setState({
                        customHelp: newValue,
                        hasContentChanged: true
                    })
                    this.refreshUi()
                }}
                //These are not needed for MVP, maybe not at all
                // isControlled={multiline === 1}//only for title
                // required={multiline === 1}//only for title
                // isValid={multiline === 1 && value.length > 0}//only for title
            />
        </div>
    }

    renderAddHelpFile() {
        return <BasicButton
            btnClass={"primary"}
            icon="pack"
            label={"Liitä tiedosto"}
            action={() => {
                openPictureImportModal({}, async (fileNameInAws) => await this.addHelpFile(fileNameInAws))
            }}
            disabled={false}
        />
    }

    async addHelpFile(fileNameInAws) {
        let newHelp = this.state.customHelp

        if ( ! newHelp.hasOwnProperty('help_files')) {
            newHelp['help_files'] = []
        }
        let newFile = {
            file_name: fileNameInAws,
        }
        const currTimeMs =  currentTimeMs()
        if (newFile['file_name'].split('.').pop() === 'pdf') {
            newFile['pdf_name'] = newFile['file_name'] + '.jpg'
            newFile['file_name'] = newFile['file_name'] + '.jpg'
        }
        newFile[ATTR_OBJ_TYPE] = OBJ_TYPE_ITM_PICT
        newFile[ATTR_CREATED_BY] = prosConnect.getUserEmail(true)
        newFile[ATTR_UPDATED_BY] = prosConnect.getUserEmail(true)
        newFile[ATTR_CREATED_MS_I] = currTimeMs
        newFile[ATTR_UPDATED_MS_I] = currTimeMs
        newFile[ATTR_OBJ_STATE] = OBJ_STATE_ACT
        newFile[ATTR_SORT_ORDER_I] = currTimeMs

        newHelp.help_files.push(newFile)
        await this.saveCustomerHelp(newHelp)
        this.refreshUi()
    }

    renderHelpFiles() {
        if ( ! this.state.customHelp.hasOwnProperty('help_files') || ! this.state.customHelp.help_files) {
            return null
        }
        let help_objs = this.state.customHelp.help_files.map(obj => {
            if ([OBJ_TYPE_ITM_PICT, OBJ_TYPE_ITM_PICT_LOC].indexOf(obj[ATTR_OBJ_TYPE]) >= 0 && obj[ATTR_OBJ_STATE] === OBJ_STATE_ACT) {
                return <UiBoxMedia
                    key={"bm__" + obj['file_name']}
                    customElement={<BasicButton
                        label={"Poista"}
                        icon={"bin"}
                        action={()=>{
                            BasicModal('Poista kuva', <>Oletko varma että haluat poistaa kuvan</>, {
                                action: async () => {
                                    obj[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL
                                    await this.saveCustomerHelp(this.state.customHelp)
                                    this.refreshUi()
                                },
                                callback: () => prosAppNotif('Kuva poistettu'),
                                btnText: 'Poista',
                                btnType: 'fatal'
                            })
                        }}
                        shrink={"md"}
                        btnType={"prompt"}
                    />}
                    no_edit={true}
                    no_thumb={obj[ATTR_CREATED_MS_I] + (10 * 1000) > currentTimeMs()}
                    item={prosConnect.getOriginal(obj)}
                    isObsAuthor={obj[ATTR_CREATED_BY] === prosConnect.getUserEmail(true)}
                />
            }
            return null
        })
        if(help_objs.length < 1) return null
        return <div className="slab grid-container grid-1 grid-2_xl">{help_objs}</div>

    }

    renderHelpObj() {
        if ( ! this.state.customHelp.hasOwnProperty(ATTR_TEXT)) {
            return this.renderTextInput(ATTR_TEXT)
        }
        return <div>
            {this.renderTextInput(ATTR_TEXT, 'Otsikko', this.state.customHelp[ATTR_TEXT])}
            { ! this.state.customHelp.hasOwnProperty(ATTR_DESCRIPTION)
                ? this.renderTextInput(ATTR_DESCRIPTION, 'Teksti')
                    : this.renderTextInput(ATTR_DESCRIPTION, 'Teksti', this.state.customHelp[ATTR_DESCRIPTION])}
        </div>
    }

    renderHelpSettings() {
        if ( ! this.state.customHelp) {
            return <h2>Ei projektikohtaista ohjetta</h2>
        }
        return <>
            <h1>Projektin ohje</h1>
            <section>
                <div className="slab">
                    <p>Projektikohtainen ohje näkyy osana Prodect-ohjetta, joka aukeaa sivun oikeaan laitaan.</p>
                </div>
                <div className="slab grid-container grid-1 grid-2_xl">
                    {this.renderHelpObj()}
                </div>
                <h2>Tiedostot</h2>
                {this.renderHelpFiles()}
                {this.renderAddHelpFile()}
            </section>
            {this.renderSaveCancelButtons()}
        </>
    }

    renderCustomerEnums() {
        return <>
            <section>
                <CustomerEnums parentNode={this} customerId={this.customerGroupId} mainProjId={this.mainProjId}/>
            </section>
        </>
    }

    renderLocationPictures() {
        if (!this.state.mainProjectId) {
            return <h2>Projektia ei ole valittu</h2>
        }
        return <SettingLocationPictures
            mainProjectId={this.state.mainProjectId}
        />
    }

    refreshUi =()=> {
        this.setState({refreshCounter: this.state.refreshCounter + 1});
    }

    selectedProjectSubprojectsWithPermission(inState, permission) {
        if (!Array.isArray(this.subprojects)) {
            return []
        }
        return this.subprojects
            .filter(project =>
                prosConnect.hasPermissionTo(permission, undefined, project, false) &&
                project[ATTR_PROJECT_STATE] === inState)
            .map(project => project.project_id)
    }

    archMenuItem(menuLabel, pids, isArchive) {
        if ( ! pids.length) {
            return null
        }
        return <li className={"dom-hide dom-show-block_md"}>
            <BasicButton
                label={menuLabel + (pids.length === 1 ? ' osaprojekti' : ' osaprojektit (' + pids.length + ')')}
                icon={(isArchive ? 'outline-lock' : 'outline-lock-open')}
                action={()=> {
                    const title = menuLabel + (pids.length === 1 ? ' osaprojekti' : ' osaprojektit (' + pids.length + ')')
                    BasicModal(title, <>Oletko varma, että haluat suorittaa toiminnon projektissa: <br/>
                        <strong>{this.state.projectName}</strong></>, {
                        action: ()=> {
                            this.setState({
                                newMainProjectName: ''
                            })
                            prosConnect.archiveActivateProjects(pids, isArchive ? OBJ_STATE_PAS : OBJ_STATE_ACT)
                        },
                        callback: () => prosAppNotif('Toiminto tehty'),
                        btnText: menuLabel
                    })
                }}
                shrink={"md"}
                btnType={"prompt"}
            />
        </li>
    }

    settingsNavigation() {
        let subProject = this.subprojects.find(sp => sp.user_role === ROLE_ADMIN)
        let mayEditPermissions = this.selectedProjectSubprojectsWithPermission(OBJ_STATE_ACT, "editAdmin").length > 0
        let activeWithPerm = this.selectedProjectSubprojectsWithPermission(OBJ_STATE_ACT, "archiveProject")
        let archivedWithPerm = this.selectedProjectSubprojectsWithPermission(OBJ_STATE_PAS, "archiveProject")
        let archiveMenuItem = this.archMenuItem('Arkistoi', activeWithPerm, true)
        let activeMenuItem = this.archMenuItem('Aktivoi', archivedWithPerm, false)
        return <>
            <li>
                <BasicButton
                    label={"Yleiset"}
                    icon={"gear"}
                    action={()=>{
                        this.setActivePage(PAGE_MAIN_SETTINGS)
                        setHelpContext('mainProj-project')
                    }}
                    hilite={this.state.activeSettingsPage === PAGE_MAIN_SETTINGS}
                    selected={this.state.activeSettingsPage === PAGE_MAIN_SETTINGS}
                    shrink={"md"}
                />
            </li>
            <li className={"dom-hide dom-show-block_md"}>
                <BasicButton
                    label={"Projektin ohje"}
                    icon={"help"}
                    action={() => {
                        this.setActivePage(PAGE_HELP_SETTINGS)
                        setHelpContext('mainProj-help')
                    }}
                    hilite={this.state.activeSettingsPage === PAGE_HELP_SETTINGS}
                    selected={this.state.activeSettingsPage === PAGE_HELP_SETTINGS}
                    shrink={"md"}
                />
            </li>
            {
                prosConnect.isSuperUserModeInUse() ?
                <li className={"dom-hide dom-show-block_md"}>
                    <BasicButton
                        label={"Sijaintikuvat"}
                        icon={"image-tack"}
                        action={()=>{
                            this.setActivePage(PAGE_LOCT_PICTS)
                        }}
                        hilite={this.state.activeSettingsPage === PAGE_LOCT_PICTS}
                        selected={this.state.activeSettingsPage === PAGE_LOCT_PICTS}
                        shrink={"md"}
                    />
                </li> : null
            }
            <li className={"dom-hide dom-show-block_md"}>
                <BasicButton
                    label={"Valintalistat"}
                    icon={"check-list"}
                    action={()=>{
                        this.setActivePage(PAGE_CUST_ENUMS)
                        setHelpContext('customer-enum-list')
                    }}
                    hilite={this.state.activeSettingsPage === PAGE_CUST_ENUMS}
                    selected={this.state.activeSettingsPage === PAGE_CUST_ENUMS}
                    shrink={"md"}
                />
            </li>
            {subProject && mayEditPermissions ?
                <li className={"dom-hide dom-show-block_md"}>
                    <BasicButton
                        label={"Käyttöoikeudet"}
                        icon={"group"}
                        action={() => {
                            this.editProjectAdminSubProjectId = subProject.project_id
                            this.setActivePage(PAGE_PROJ_PERMS)
                        }}
                        hilite={this.state.activeSettingsPage === PAGE_PROJ_PERMS}
                        selected={this.state.activeSettingsPage === PAGE_PROJ_PERMS}
                        shrink={"md"}
                    />
                </li>
                : null
            }
            {archiveMenuItem}
            {activeMenuItem}
            <li className={"dom-hide dom-show-block_md"}>
                <BasicButton
                    label={"Poista projekti"}
                    icon={"bin"}
                    action={()=>{
                        BasicModal('Poista projekti ja kaikki osaprojektit?', <>Oletko varma että haluat poistaa projektin
                            <strong> {this.state.projectName}</strong> ja sen osaprojektit sisältöineen?<br/>
                            <strong className={"color-2nd"}>Poistettuja tietoja ei voi palauttaa toiminnon jälkeen.</strong>
                        </>, {
                            action: async () => {
                                await this.deleteMainProject()
                            },
                            callback: ()=> prosAppNotif('Projekti ' + this.state.projectName + ' poistettu'),
                            btnText: 'Poista projekti',
                            btnType: 'fatal'
                        })
                    }}
                    shrink={"md"}
                    btnType={"prompt"}
                />
            </li>
        </>
    }

    renderSideBar() {
        return  <nav className={"side-nav settings-sidebar"}>
            <ul className={"navigation"}>
                {this.settingsNavigation()}
            </ul>
        </nav>
    }

    renderSettingsSubpage() {
        switch (this.state.activePage) {
            case PAGE_CUST_ENUMS:
                return this.renderCustomerEnums()
            case PAGE_HELP_SETTINGS:
                return this.renderHelpSettings()
            case PAGE_LOCT_PICTS:
                return <h2>WIP</h2>
            case PAGE_PROJ_PERMS:
                return <PermissionManagement
                    showSingleSubProject={false}
                    subProjectId={this.editProjectAdminSubProjectId}
                />
            case PAGE_MAIN_SETTINGS:
            default:
                return this.renderMainProjectSettings()
        }
    }

    render() {
        require("./assets/scss/ProjectSettings.scss");
        if (this.state.loading) {
            return <LoadingAnimation size={"lg"} />
        }
        return <>
            <div className={"side-nav-container project-settings " + this.state.activeSettingsPage}>
                {this.renderSideBar()}
                <div className={"side-nav-page"}>
                    {this.renderSettingsSubpage()}
                </div>
            </div>
            {prosPopupRender(this, "ProjectSettings")}
        </>
    }
}